import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import { preset } from 'vue-cli-plugin-vuetify-preset-owl/preset'
import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify);

export default new Vuetify({
    rtl: false,
    theme: {
        themes: {
            light: {
                primary: colors.cyan,
                secondary: colors.grey.darken1,
                accent: colors.cyan.accent1,
                error: colors.red.accent3,
                background: colors.indigo.lighten5
            },
            dark: {
                primary: colors.cyan.lighten1,
                background: colors.indigo.base
            }
        }
    }
});